import React from 'react';
import MiddleSection from '../MiddleSection/MiddleSection';
import TopSection from '../TopSection/TopSection';

const Home = () => {
    return (
        <div>
            <TopSection></TopSection>
            <MiddleSection></MiddleSection>
        </div>
    );
};

export default Home;